// extracted by mini-css-extract-plugin
module.exports = {"price":"PriceRange_price__KOQ5L","strikeThrough":"PriceRange_strikeThrough__iIyqo"};